<template lang="pug">
  div
    .medias(v-if="Object.values(galleries).length > 0")
      h1.title Gallery
      f-file(:files="galleries")
    .medias(v-if="Object.values(documents).length > 0")
      h1.title Documents
      f-file(:files="documents")
</template>

<script>
import FFile from '@/components/FFile'
import path from 'path'

export default {
  props: {
    media: {

    }
  },
  components: {
    FFile
  },
  computed: {
    files () {
      if (this.media) {
        return JSON.parse(this.media)
      } else {
        return {}
      }
    },
    galleries () {
      return Object.keys(this.files).reduce((result, key) => {
        const file = this.files[key]
        if (this.isImage(file.path)) {
          result[key] = file
        }
        return result
      }, {})
    },
    documents () {
      return Object.keys(this.files).reduce((result, key) => {
        const file = this.files[key]
        if (!this.isImage(file.path)) {
          result[key] = file
        }
        return result
      }, {})
    }
  },
  methods: {
    isImage (filepath) {
      const ext = path.extname(filepath)
      return ['.jpg', '.png'].indexOf(ext) >= 0
    },
    isVideo (filepath) {
      const ext = path.extname(filepath)
      return ['.mp4', '.mov'].indexOf(ext) >= 0
    }
  }
}
</script>

<style lang="scss" scoped>
.medias {
  border-top: 1px solid #ddd;
  padding: 20px 0;
}
h1.title {
  font-size: 18px;
  color:#ddd;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Media.vue